import { PublicHolidayComponent } from './public-holiday/public-holiday.component';
import { PublicHolidaysComponent } from './public-holidays.component';
import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BnsightsLibraryModule } from 'bnsights-control-library';
import { BlockUIModule } from 'ng-block-ui';
import { DataSecretService } from '../shared/Services/data.service';
import { AuthModule } from '../core/auth.module';
import { PublicHolidaysRoutingModule } from './public-holidays-routing.module';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatMenuModule } from '@angular/material/menu';
import { InlineSVGModule } from 'ng-inline-svg';
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bnsights-utilities-library';
import { PublicHolidayService } from '../shared/Services/PublicHolidayService.service';

@NgModule({
  declarations: [PublicHolidayComponent, PublicHolidaysComponent],
  imports: [
    PublicHolidaysRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BnsightsLibraryModule,
    MatMenuModule,
    NgbModule,
    InlineSVGModule,
    EmptyDataModule
    
  ],
  providers:[
    EnvironmentService,
    DataSecretService,
    UtilityService,
    AuthService,
    BBSFTranslateService, 
    PublicHolidayService
  ]
})
export class PublicHolidaysModule { }
